import qs from 'qs'
import axios from '@/api/apiClient'
import { encryption } from '@/utils/util'
const api = {
  // @phone 后面需添加phone /{phone}
  // 生成图片验证码
  ImgCode: '/api/index/validatecode',

  // 检查手机是否已注册
  CheckPhone: '/api/member/info/checkphone',
  // 检查图形验证码是否正确
  CheckImgCode: '/api/member/info/checkvalidatecode',

  // 注册发送手机验证码
  SendSms: '/api/member/info/register/verifycode',
  // 注册
  Register: '/api/member/info/register',

  // 找回密码 //@phone 后面需添加phone /{phone}
  Resetpass: '/api/member/info/resetpass',
  // 找回密码-发送手机验证码 /{phone}
  ResetSendSms: '/api/member/info/resetpass/verifycode',
  // 登录
  Login: '/auth/oauth/token',
  UpdateToken: '/auth/oauth/token',
  // 2020年10月10日
  checkLoginName: '/api/member/info/checkloginName',

  MyInfo: '/api/member/myinfo',
}
export default api

// --- 优化 getUserDetail ---
// 用一个变量来保存正在进行的请求 Promise
let getUserDetailPromise = null

/**
 * 注册-检查登录名是否已经注册
 * @param {*} loginName 邮箱|手机|子账户
 */
export function checkLoginName(loginName) {
  return axios.$get(`${api.checkLoginName}/${loginName}`)
}

/**
 * 刷新token
 * @param {String} refresh_token refresh_token 值(登录接口有返回)
 * @param {String} grant_type 固定值refresh_token
 * @param {String} scope 固定值server
 */
export function getUpdateToken(refreshToken) {
  const query = {
    refresh_token: refreshToken,
    grant_type: 'refresh_token',
    scope: 'server',
  }
  return axios.$get(`${api.UpdateToken}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 注册-检查手机号是否已经注册
export function checkPhone(phone) {
  return axios.$get(`${api.CheckPhone}/${phone}`)
}

// 注册-检查图形验证码
export function checkImgCode(phone, code) {
  return axios.$get(`${api.CheckImgCode}/${phone}?code=${code}`)
}
// 注册-发送手机验证码
export function getSmsCaptcha(phone) {
  return axios.$get(`${api.SendSms}/${phone}`)
}

// 找回密码-发送手机验证码
export function getResetSmsCaptcha(phone) {
  return axios.$get(`${api.ResetSendSms}/${phone}`)
}
// 找回密码
export function resetpass(parameter) {
  console.log('找回密码:', parameter, qs.stringify(parameter))
  return axios.$post(api.Resetpass, parameter)
}

// 注册
export function register(parameter) {
  console.log('注册参数:', parameter, qs.stringify(parameter))
  return axios.$post(api.Register, parameter)
}

/**
 * 登录接口
 * @param {*} parameter.username 登录用户名
 * @param {*} parameter.password 密码
 * @param {*} parameter.grant_type 默认password
 * @param {*} parameter.scope 默认server
 * @returns token 后端控制超时时间
 */
export function login(parameter) {
  parameter.password = encryption(parameter.password)
  return axios.$get(api.Login, {
    params: parameter,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      Authorization: `Basic ${window.btoa('pc:yunhzh-pc')}`,
    },
  })
}

// 获取我的主要信息
export function getUserDetail(token) {
  // 如果已经有一个请求在路上了，就别再发新的了，直接用那个 Promise 就好啦！笨蛋！
  if (getUserDetailPromise) {
    console.log('getUserDetail: 哼！请求已经在处理中了，直接返回给你现成的 Promise！')
    return getUserDetailPromise
  }

  console.log('getUserDetail: 好吧，这次就帮你发个新请求吧...')

  let option = {}
  if (token) {
    // 真是麻烦，还要手动加 Header
    option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  } else {
    // 如果没传 token，可能用的是 axios 实例里默认的拦截器 token，或者就是不需要 token 的情况
    console.log('getUserDetail: 注意哦，这次没传 token，希望 axios 拦截器能搞定！')
  }

  // 把新的请求 Promise 存起来！
  getUserDetailPromise = axios
    .$get(api.MyInfo, option)
    .then((response) => {
      console.log('getUserDetail: 请求成功啦！(〃∀〃)ゞ')
      // 请求成功了，记得把 Promise 清掉，不然下次就不发新请求了！
      getUserDetailPromise = null
      return response // 把结果给你
    })
    .catch((error) => {
      console.error('getUserDetail: 呜...请求失败了...', error)
      // 请求失败了也要清掉 Promise，不然下次出错了还用旧的失败 Promise 就不好了！
      getUserDetailPromise = null
      // 把错误丢出去，让调用它的地方自己处理去！
      throw error
    })

  // 返回这个存起来的 Promise
  return getUserDetailPromise
}

/**
 * 退出登录
 */
export function logout() {
  getUserDetailPromise = null

  return axios.$delete('/auth/token/logout')
}

/**
 * @description: 微信登录接口
 * @param {*} parameter
 * @return {*}
 */
export function wechatLogin(code) {
  return axios.$get('/api/wechat/loginByWeChatQR', {
    params: {
      code,
    },
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      Authorization: `Basic ${window.btoa('pc:yunhzh-pc')}`,
    },
  })
}

/**
 * @description: 微信登录 微信绑定发送验证码
 * @param {*} phone
 * @return {*}
 */
export function getWxbindcode(phone) {
  return axios.$get(`/api/member/info/wxbindcode/verifycode/${phone}`)
}

/**
 * @description: 微信绑定登录接口
 * @param {*} query.verifycode 验证码
 * @param {*} query.openid 微信openid
 * @param {*} query.phone 手机号
 * @param {*} query.selorigin 是否同意用户协议 1-同意,0-不同意
 * @param {*} query.nickName 昵称
 * @param {*} query.avatarUrl 头像
 * @return {*}
 */
export const wxBindCode = (query) => {
  return axios.$get(`/auth/wx/bindcode${query ? `?${qs.stringify(query)}` : ''}`, {
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      Authorization: `Basic ${window.btoa('pc:yunhzh-pc')}`,
    },
  })
}

/**
 * @description:短信验证登录发送验证码
 * @param {*}
 * @return {*}
 */
export const sendSmsLoginCode = (phone) => {
  return axios.$get(`/api/smsLogin/sendVerifyCode/${phone}`, {
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      Authorization: `Basic ${window.btoa('pc:yunhzh-pc')}`,
    },
  })
}

export const smsLogin = (parameter) => {
  return axios.$get('/api/smsLogin/verifyLogin', {
    params: parameter,
    headers: {
      Authorization: `Basic ${window.btoa('pc:yunhzh-pc')}`,
    },
  })
}

// 判读是否第一次登录
export const firstLogin = () => {
  return axios.$get('/api/member/loginlog/getFirstLogin')
}

/**
 * 首次登录成功的引导页埋点
  type 记录类型(0:关闭引导页和返回首页 1:创建AI智能名片 2:搭建企业云展系统 3:领取客户线索 4:邀约触达客户)
 */
export const firstLoginSuccess = (type) => {
  return axios.$get(`/api/guide/save?type=${type}`)
}
